import { Component } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent {
  readonly values = [
    {
      title: '技术务实',
      description: '围绕 RIP、可变数据、自动排版与生产流程协同，持续打磨真正能落地的工业打印工具。'
    },
    {
      title: '响应快速',
      description: '从试用、部署到问题排查，我们更强调直接有效的沟通和稳定持续的交付节奏。'
    },
    {
      title: '长期合作',
      description: '我们希望成为企业生产链路中的长期伙伴，而不是一次性的软件供应方。'
    }
  ];

  readonly milestones = [
    {
      year: '产品方向',
      title: '聚焦工业打印软件',
      description: '围绕广告喷绘、可变数据、文档编辑与智能排版等场景，建立统一的产品能力体系。'
    },
    {
      year: '服务方式',
      title: '从单点功能到完整流程',
      description: '不仅提供软件本身，也关注部署、适配、培训、流程衔接与后续支持。'
    },
    {
      year: '合作目标',
      title: '帮助客户稳定提效',
      description: '通过更清晰的流程、更高的输出一致性和更低的返工成本，帮助业务持续增长。'
    }
  ];

  readonly capabilities = [
    '面向工业打印与文档生产场景的专业软件研发',
    '支持企业级试用、部署、升级与长期维护',
    '提供从网站咨询到商务沟通的完整服务链路',
    '持续迭代 Porcelain、Instrument、Abundance 等产品线'
  ];
}
